import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Footer from './components/Footer';
import Home from './components/Home';
import Header from './components/Header';
import WhatsAppButton from './components/WhatsAppButton'; 
import ContactUs from './components/ContactUs';
import SectorsGrid from './components/SectorsGrid';
import Fleet from './components/Fleet';
import AirportServices from './components/Services/AirportServices';
import BusinessSameDayService from './components/Services/BusinessSameDayService';
import BespokeSolutions from './components/Services/BespokeSolutions';
import ChristmasDelivery from './components/Services/ChristmasDelivery';
import CrematedRemains from './components/Services/CreamatedRemains';
import DomesticSameDayService from './components/Services/DomesticSameDayService';
import EbayPickupDropService from './components/Services/EbayPickupDropService';
import EducationalCourierService from './components/Services/EducationalCourierService';
import EmergencyCourierServices from './components/Services/EmergencyCourierServices';
import ForgottenItemsService from './components/Services/ForgottenItemsService';
import IndustrialEstates from './components/Services/IndustrialEstates';
import MedicalDelivery from './components/Services/MedicalDelivery';
import OvernightDelivery from './components/Services/OvernightDelivery';
import StudentRemovalServices from './components/Services/StudentRemovalServices';
import TwoManDeliveryService from './components/Services/TwoManDeliveryService';
import UrgentDocumentDelivery from './components/Services/UrgentDocumentDelivery';
import WeekendCourierService from './components/Services/WeekendCourierService';
import AboutUs from './components/Services/AboutUs';
import Support from './components/Support';
import AirFreightServices from './components/Services/AirFreightServices';
import EuropeanAirFreight from './components/Services/EuropeanAirFreight';
import Shippingservices from './components/Shippingservices';
import ScrollToTop from './components/ScrollToTop';
import RelocationServices from './components/RelocationServices';

function App() {
  return (
    <Router>
        <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sector" element={<SectorsGrid />} />
        <Route path="/fleet" element={<Fleet />} />
        <Route path="/relocation" element={<RelocationServices />} />
        <Route path="/airportservices" element={<AirportServices />} />
        <Route path="/airfreightservice" element={<AirFreightServices />} />
        <Route path="/europeanservices" element={<EuropeanAirFreight />} />
        <Route path="/businesssamedayservices" element={<BusinessSameDayService />} />
        <Route path="/bespoke" element={<BespokeSolutions />} />
        <Route path="/christmas" element={<ChristmasDelivery />} />
        <Route path="/Cremated" element={<CrematedRemains />} />
        <Route path="/domesticsameday" element={<DomesticSameDayService />} />
        <Route path="/ebaypickupdropoff" element={<EbayPickupDropService />} />
        <Route path="/educationcourier" element={<EducationalCourierService />} />
        <Route path="/emergencycourier" element={<EmergencyCourierServices />} />
        <Route path="/forgottensomething" element={<ForgottenItemsService />} />
        <Route path="/industrialestates" element={<IndustrialEstates />} />
        <Route path="/medicaldeliveries" element={<MedicalDelivery />} />
        <Route path="/overnightdelivery" element={<OvernightDelivery />} />
        <Route path="/studentremovals" element={<StudentRemovalServices />} />
        <Route path="/twomandelivery" element={<TwoManDeliveryService />} />
        <Route path="/urgentdocuments" element={<UrgentDocumentDelivery />} />
        <Route path="/weekendcouriers" element={<WeekendCourierService />} />

        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/support" element={<Support />} />
        <Route path="/shipping" element={<Shippingservices />} />


        <Route path="/contactus" element={<ContactUs />} />
      </Routes>
      <Footer />
      
      {/* WhatsApp button will appear on all pages */}
      <WhatsAppButton />
    </Router>
  );
}

export default App;
